import { memo } from 'react';
import { Flex, Text, tokens, Tooltip } from '@optiaxiom/react';

import { NodeIcon } from '../NodeIcon';

import * as styles from './NodeHeader.css';

type NodeHeaderProps = {
  iconInfo?: {
    icon: React.ComponentType<{ size?: string | number }>;
    color: keyof typeof tokens.colors;
  };
  label: string;
  nodeType: string;
  category?: string;
  variant?: 'default' | 'condition';
};

export const NodeHeader = memo(
  ({ iconInfo, label, nodeType, category, variant = 'default' }: NodeHeaderProps) => (
    <Flex className={styles.nodeHeader}>
      <NodeIcon
        Icon={iconInfo?.icon}
        color={iconInfo?.color}
        nodeType={nodeType}
        category={category}
        variant={variant === 'condition' ? 'condition' : undefined}
      />
      <Tooltip content={label}>
        <Text lineClamp="1" className={styles.nodeLabel}>
          {label}
        </Text>
      </Tooltip>
    </Flex>
  )
);

NodeHeader.displayName = 'NodeHeader';
